<template>
  <div id="app">
    <WebHeader></WebHeader>
    <router-view/>
    <WebFooter></WebFooter>
  </div>
</template>

<script>
import WebHeader from './components/header/header'
import WebFooter from './components/footer/footer'
export default {
  name: 'App',
  components: {
    WebHeader,
    WebFooter
  }
}
</script>

<style>
#app,#app a {
  font-family:Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  /* font-size: 16px; */
  text-decoration: none;
}
#app{
  box-sizing: border-box;
  min-height: 100%;
  padding-bottom: 260px;
  position: relative;
}
.container{
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue